export const selectSettingsState = (state) => state.settings;

export const selectActiveTab = (state) => state.settings.activeTab;
export const selectAcronymIgnore = (state) => state.settings.acronymIgnore;
export const selectDiscoveryIgnore = (state) => state.settings.discoveryIgnore;
export const selectReadabilityIgnore = (state) =>
  state.settings.readabilityIgnore;
export const selectThresholds = (state) => state.settings.thresholds;
export const selectBusinessAlignmentProfile = (state) =>
  state.settings.bestFitProfiles.samGov.profile;
export const selectBusinessAlignmentProfileAlreadySetup = (state) =>
  state.settings.bestFitProfiles.samGov.isSetup;
export const selectEBuyProfile = (state) =>
  state.settings.bestFitProfiles.eBuy.profile;
export const selectEBuyProfileIsSetup = (state) =>
  state.settings.bestFitProfiles.eBuy.isSetup;
export const selectUkTenderProfile = (state) =>
  state.settings.bestFitProfiles.ukTender.profile;
export const selectUkTenderProfileIsSetup = (state) =>
  state.settings.bestFitProfiles.ukTender.isSetup;
export const selectBestFitProfileSaveProgress = (state, key) =>
  state.settings.bestFitProfiles[key]?.saveProgress ?? null;
